import type { Schemas } from '@argzombie/api-client';

// The beat engine's content types (shared-cs Content/BeatDefs.cs, EffectDefs.cs, AllyDefs.cs, PanelSpec.cs), from the generated client.
export type BeatChainDef = Schemas['BeatChainDef'];
export type BeatDef = Schemas['BeatDef'];
export type ChoiceDef = Schemas['ChoiceDef'];
/** Day Zero adds `showIf` (hides the option; reads only ticket.varHas). */
export type OptionDef = Schemas['OptionDef'] & { showIf?: Schemas['CondDef'] | null };
export type OutcomeDef = Schemas['OutcomeDef'];
/** Card 19: shared-cs `StatWeightDef`, a table case's stat-weighted odds. */
export type StatWeightDef = Schemas['StatWeightDef'];
export type OutcomeTableCase = Schemas['OutcomeTableCase'];
export type OutcomePickDef = Schemas['OutcomePickDef'];
/** Day Zero adds `deal` (a hand dealt from a list; scenario hidden vars only). */
export type HiddenVarDef = Schemas['HiddenVarDef'] & {
  deal?: { from?: string[] | null; count?: number; avoid?: Schemas['CondDef'] | null } | null;
};
export type HiddenVarCaseDef = Schemas['HiddenVarCaseDef'];
export type TellDef = Schemas['TellDef'];
export type CastRoleDef = Schemas['CastRoleDef'];
export type CellDef = Schemas['CellDef'];
export type CondDef = Schemas['CondDef'];
/** Card 19: shared-cs `EffectTrainBlock` and `EffectApplyBlock` (the server-only `train` and `apply_effect` effects). */
export type EffectTrainBlock = Schemas['EffectTrainBlock'];
export type EffectApplyBlock = Schemas['EffectApplyBlock'];
export type EffectDef = Schemas['EffectDef'];
export type AllyDef = Schemas['AllyDef'];
export type StoryRulesDef = Schemas['StoryRulesDef'];
export type StoryToneMixDef = Schemas['StoryToneMixDef'];
export type PanelSpec = Schemas['PanelSpec'];
export type PanelActorDef = Schemas['PanelActorDef'];
export type PanelRulesDef = Schemas['PanelRulesDef'];
export type PronounSetDef = Schemas['PronounSetDef'];
export type NpcDef = Schemas['NpcDef'];

/** shared-cs `BeatChainStatuses.All`. */
export const BEAT_CHAIN_STATUSES = ['live', 'dev_only', 'retired'] as const;
/** shared-cs `OutcomeTones.All`, worst to best (the tone scale). */
export const OUTCOME_TONES = ['disaster', 'bad', 'mixed', 'good', 'windfall'] as const;
export type Tone = (typeof OUTCOME_TONES)[number];
/** shared-cs `CondOps.All`. */
export const COND_OPS = ['eq', 'ne', 'gte', 'lte', 'in'] as const;
/** shared-cs `CastBinds.All`. */
export const CAST_BINDS = ['squad_member', 'npc', 'ledger', 'ally'] as const;
/** Hidden variable types (engine.html §5): bool, int (0..99) or enum. */
export const HIDDEN_VAR_TYPES = ['bool', 'int', 'enum'] as const;

/** `BeatRules.MaxDepth`: the hard cap on choices per path; content (`story.maxDepth`) can lower it, never raise it. */
export const MAX_DEPTH = 4;
